// @ts-nocheck
import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import { Sidebar, FormDonation, DonationPlaceholder } from './'
import PropTypes from 'prop-types'
import { Alert } from 'loyal-react'
import ModalTermsDonation from '../CellphoneRecharge/ModalTermsDonation/ModalTermsDonation'
import '@loyal_template/services.css'

import { SecondFactorAuthentication } from '../Checkout/SecondFactorAuthenticaton'

import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'

const showError = (error, handlerCloseError) =>
  error ? (
    <Alert
      isError
      title={'Não foi possível concluir sua transferência'}
      description={
        'Vamos tentar novamente, por favor verifique os campos baixo.'
      }
      className='pb-2'
      onClose={() => handlerCloseError()}
    />
  ) : (
    ''
  )

const customError = (error) =>
  error ? (
    <Alert
      isError
      title={error.title}
      description={
        error.description
      }
      className='pb-2'
      onClose={() => error.closeError()}
    />
  ) : (
    ''
  )

const Donation = ({
  isloading,
  isLoadingChangeAccountType,
  accountType,
  handlerChangeAccountType,
  handlerGetBarCode,
  handlerGetData,
  handlerFinalizePayment,
  handlerListInstitutions,
  handlerFinalizeDonation,
  institutions,
  handlerConvertionPointsToCash,
  handlerServiceId,
  handlerDonatedPoints,
  handlerCloseError,
  billValue,
  participantPoints,
  isPriceEditable,
  barCode,
  data,
  errorPage,
  errorField,
  name,
  loadingPayment,
  showTerms,
  closeterms,
  acceptTerms,
  acceptTermsEvent,
  showTermsEvent,
  vendorId,
  catalogId,
  sendRedemptionError,
  donationPointsValue,
  convertedValue,
  imageUrl,
  validateConversion,
  secondFactorAuthentication,
  oidc,
  closeModal,
  authorizeWithTokenResend,
  authorizeWithToken,
  authorizeWithTokenLastTry,
  isCreatingPurchase,
  errorToken
}) => (
  <Fragment>
    <Helmet>
      <title>{`Doação - ${process.env.REACT_APP_TITLE || ''}`}</title>
    </Helmet>
    <ReactPlaceholder
      ready={!isloading}
      customPlaceholder={<DonationPlaceholder />}
    >
      <div className='container-fluid px-0 px-md-1 pt-0'>
        <div className='container pt-0 pt-md-5 pb-3 py-md-0'>
          <div className='row pt-0'>
            {showError(sendRedemptionError, handlerCloseError)}
            {customError(errorPage)}
            <div className='col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2 '>
              <div className='row mx-0'>
                <div className='col-12 radius border border-color-ui-3'>
                  <div className='row'>
                    <div className='col-12'>
                      <div className='bg-servicos-donation radius-top row align-items-center px-1'>
                        <div className='col-12 px-3'>
                          <h2 className='color-ui-white txt-title-2 txt-circular-book'>
                            Ajude-nos a fazer mais
                            <br />
                            por quem precisa
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='row radius-bottom bg-white px-1'>
                    <div className='col-12 px-2 py-2'>
                      <p className='txt-body-sm'>
                        Selecione a quantidade de reales, a instituição que você
                        quer ajudar e faremos um resgate.
                      </p>
                      <p className='txt-body-sm border-dashed-bottom border-color-ui-3 pb-2'>
                        Sua contribuição faz toda a diferença!
                      </p>
                    </div>
                    <div className='col-12 px-3'>
                      <FormDonation
                        accountType={accountType}
                        handlerConvertionPointsToCash={
                          handlerConvertionPointsToCash
                        }
                        handlerServiceId={handlerServiceId}
                        handlerChangeAccountType={handlerChangeAccountType}
                        handlerGetBarCode={handlerGetBarCode}
                        handlerGetData={handlerGetData}
                        handlerDonatedPoints={handlerDonatedPoints}
                        institutions={institutions}
                        handlerListInstitutions={handlerListInstitutions}
                        billValue={billValue}
                        pointsValue={participantPoints}
                        isPriceEditable={isPriceEditable}
                        barCode={barCode}
                        errorField={errorField}
                        isloading={isloading}
                        isLoadingChangeAccountType={isLoadingChangeAccountType}
                        vendorId={vendorId}
                        imageUrl={imageUrl}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ModalTermsDonation
              show={showTerms}
              terms={{
                type: 'Vendor',
                vendorId: vendorId,
                catalogId: catalogId
              }}
              onClose={closeterms}
              acceptTerms={acceptTermsEvent}
            />
            <Sidebar
              barCode={barCode}
              name={name}
              data={data}
              billValue={billValue}
              donationPointsValue={donationPointsValue}
              convertedValue={convertedValue}
              handlerFinalizePayment={handlerFinalizePayment}
              handlerFinalizeDonation={handlerFinalizeDonation}
              loadingPayment={loadingPayment}
              showTermsEvent={showTermsEvent}
              acceptTermsEvent={acceptTermsEvent}
              acceptTerms={acceptTerms}
              validateConversion={validateConversion}
            />
          </div>
        </div>
        {secondFactorAuthentication && secondFactorAuthentication.enable && (
          <div className='modalConfirmationVoucher'>
            <SecondFactorAuthentication
              show={secondFactorAuthentication && secondFactorAuthentication.enable}
              secondFactorAuthConfirmated={secondFactorAuthentication && secondFactorAuthentication.AuthenticationConfirmed}
              confirmedOrderId={secondFactorAuthentication && secondFactorAuthentication.confirmedOrderId}
              oidc={oidc}
              {...this.props}
              paymentSelected='POINTS_ONLY'
              closeModal={closeModal}
              authorizeWithTokenResend={authorizeWithTokenResend}
              authorizeWithToken={authorizeWithToken}
              authorizeWithTokenLastTry={authorizeWithTokenLastTry}
              isCreatingPurchase={isCreatingPurchase}
              errorToken={errorToken}
            />
          </div>
        )}
      </div>
    </ReactPlaceholder>
  </Fragment>
)

Donation.propTypes = {
  isloading: PropTypes.bool,
  isLoadingChangeAccountType: PropTypes.bool,
  loadingPayment: PropTypes.bool,
  accountType: PropTypes.array,
  handlerChangeAccountType: PropTypes.func,
  handlerGetBarCode: PropTypes.func,
  handlerGetData: PropTypes.func,
  handlerFinalizePayment: PropTypes.func,
  handlerListInstitutions: PropTypes.func,
  handlerConvertionPointsToCash: PropTypes.func,
  institutions: PropTypes.array,
  handlerCloseError: PropTypes.func,
  handlerCloseSuccess: PropTypes.func,
  billValue: PropTypes.number,
  pointsValue: PropTypes.any,
  participantPoints: PropTypes.number,
  isPriceEditable: PropTypes.bool,
  barCode: PropTypes.string,
  data: PropTypes.string,
  name: PropTypes.string,
  errorPage: PropTypes.object,
  successPage: PropTypes.object,
  errorField: PropTypes.bool,
  showTerms: PropTypes.bool,
  showTermsEvent: PropTypes.func,
  closeterms: PropTypes.func,
  acceptTerms: PropTypes.bool,
  acceptTermsEvent: PropTypes.func,
  vendorId: PropTypes.number,
  catalogId: PropTypes.number,
  sendRedemptionError: PropTypes.bool,
  handlerServiceId: PropTypes.func,
  handlerDonatedPoints: PropTypes.func,
  donationPointsValue: PropTypes.any,
  convertedValue: PropTypes.number,
  handlerFinalizeDonation: PropTypes.func,
  imageUrl: PropTypes.string,
  validateConversion: PropTypes.bool,
  secondFactorAuthentication: PropTypes.object,
  oidc: PropTypes.object,
  errorToken: PropTypes.bool,
  secondFactorAuthSuccess: PropTypes.bool,
  secondFactorAuthenticationConfirmed: PropTypes.bool,
  confirmedOrderId: PropTypes.number,
  closeModal: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  authorizeWithToken: PropTypes.func,
  authorizeWithTokenLastTry: PropTypes.func,
  isCreatingPurchase: PropTypes.bool
}

export default Donation



// WEBPACK FOOTER //
// ./src/features/Donation/Donation.js